// Rótulo do documento de transporte (PO1-3299, épico PO1-3298).
//
// A Conhecimentotransporte guarda CT-e (modelo 57) e, desde o épico PO1-3298,
// também NFse (modelo 99). Registro antigo vem sem modelo
// (null) e é CT-e. Toda tela que mostra "CT-e" por documento passa a usar
// `rotuloDocumento(doc.modelo)`; cabeçalhos de coluna que listam documentos
// viram "Documento". Convenção do Hub: "NFse" sem hífen, "CT-e" com hífen.

export const MODELO_DOCUMENTO = Object.freeze({ CTE: 57, NFSE: 99 });

export function ehNfse(modelo) {
  return Number(modelo) === MODELO_DOCUMENTO.NFSE;
}

export function rotuloDocumento(modelo) {
  return ehNfse(modelo) ? "NFse" : "CT-e";
}

// Plural para contadores ("3 CT-e(s)" x "3 NFse(s)" não existe: quando a lista
// mistura modelos usa-se "documento(s)").
export function rotuloDocumentos(itens = []) {
  const lista = Array.isArray(itens) ? itens : [];
  const modelos = new Set(lista.map((d) => rotuloDocumento(d && d.modelo)));
  if (modelos.size === 1) return `${[...modelos][0]}(s)`;
  return "documento(s)";
}

export default rotuloDocumento;
